(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/constants.js');

'use strict';

const CONSTANTS = {
  DRAW_STATE: {
    OPEN: 2,
    REG_CLOSED: 3,
    CANCEL_CLOSED: 4,
    FINALIZED: 20
  },
  DRAW_TYPE: {
    ANDRA_CHANSEN: 1,
    AFTER_DROMVINSTEN: 2
  }
};
if (svs.isServer) {
  module.exports = CONSTANTS;
} else {
  svs.numbergames.andra_chansen.CONSTANTS = CONSTANTS;
}

 })(window);